'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _selectOnFocus = require('./selectOnFocus');

var _selectOnFocus2 = _interopRequireDefault(_selectOnFocus);

var _provideActiveInfo = require('../enhancers/provideActiveInfo');

var _provideActiveInfo2 = _interopRequireDefault(_provideActiveInfo);

var _autofillOnFocus = require('../enhancers/autofillOnFocus');

var _autofillOnFocus2 = _interopRequireDefault(_autofillOnFocus);

var _applyParser = require('./applyParser');

var _applyParser2 = _interopRequireDefault(_applyParser);

var _formatValue = require('./formatValue');

var _formatValue2 = _interopRequireDefault(_formatValue);

var _controlInputValue = require('./controlInputValue');

var _controlInputValue2 = _interopRequireDefault(_controlInputValue);

var _controlDocValue = require('./controlDocValue');

var _controlDocValue2 = _interopRequireDefault(_controlDocValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import pure from 'recompose/pure'

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  type: _propTypes.string,
  value: _propTypes.any,
  onChange: _propTypes.func.isRequired,

  onFocus: _propTypes.func,
  onBlur: _propTypes.func,

  formatter: _propTypes.func,
  formatterWhenFocused: _propTypes.func,
  parser: _propTypes.func,

  defaultWhenFocused: _propTypes.any,
  autofill: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object])
}),

// if formatterWhenFocused is undefined,
// it will use defaultFormatter in `formatValue`
_provideActiveInfo2.default, // => isFocused
(0, _withProps2.default)(function (_ref) {
  var isFocused = _ref.isFocused,
      formatterWhenFocused = _ref.formatterWhenFocused,
      formatter = _ref.formatter,
      type = _ref.type;
  return {
    formatter: isFocused ? formatterWhenFocused : formatter,
    type: isFocused && type === 'number' ? 'number' : 'text'
  };
}), _autofillOnFocus2.default,

// exchange value and string by formatter and parser
_applyParser2.default, _formatValue2.default,

// control text input, only update doc value on blur
_controlInputValue2.default, _controlDocValue2.default, _selectOnFocus2.default, (0, _exposeProps2.default)(['type', 'value', 'onChange', 'onFocus', 'onBlur']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'inputByTyping');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/inputByTyping.js
// module id = 1725
// module chunks = 0